// --------------------------------------------------------------
// Created On: 2024-07-02
// Author: Zachary Thomas
//
// Last Modified: 2026-10-30
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants related to polling data periodically.
// Note: Delay is being added to max inactivity time to account for guaranteed inactivity that is applied to the user
// that happens during each initial polling check. This cycle is required to dramatically reduce the number
// of re-renders that have to be processed.
export const DASHBOARD_POLLING_DELAY_SECONDS = 60;
export const DASHBOARD_MAX_INACTIVE_USER_SECONDS = 600 + DASHBOARD_POLLING_DELAY_SECONDS;
export const DASHBOARD_SYSTEM_CONTROL_POLLING_DELAY_SECONDS = 10;
export const DASHBOARD_SYSTEM_CONTROL_MAX_INACTIVE_USER_SECONDS = 600 + DASHBOARD_SYSTEM_CONTROL_POLLING_DELAY_SECONDS;
export const ASSET_DETAILS_POLLING_DELAY_SECONDS = 5;
export const ASSET_DETAILS_MAX_INACTIVE_USER_SECONDS = 120 + ASSET_DETAILS_POLLING_DELAY_SECONDS;
export const CHECK_NOTIFICATIONS_POLLING_DELAY_SECONDS = 10;
export const CHECK_NOTIFICATIONS_MAX_INACTIVE_USER_SECONDS = 120 + CHECK_NOTIFICATIONS_POLLING_DELAY_SECONDS;
export const LLM_AGENT_MAX_POLLING_TIME_SECONDS = 900;
